import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';

import { Configuration } from '../../shared/configuration/shared.config';

const BASE_URL = Configuration.adminApiUrl;

@Injectable()
export class CoreService {

    constructor(private http: HttpClient) {
    }

    signup(user) {
        return this.http.post(`${BASE_URL}/api/v1/admin/signup`, { user });
    }

    login(user) {
        return this.http.post(`${BASE_URL}/api/v1/admin/login`, { user });
    }
}
